export class FiscalYearOption {
    constructor(id, startDate, endDate) {
        this.id = id;
        this.startDate = startDate;
        this.endDate = endDate;
        this.posString = (startDate.getMonth()+1) + "/" +startDate.getFullYear() + " - " + (endDate.getMonth()+1) + "/" + endDate.getFullYear();
    }
}

